import jiwakilisheLogo from '../assets/images/jiwakilishe_logo.png';
import thriveEmpowermentLogo from '../assets/images/thrive_empowerment_logo.jpg';
import tioConsultancyLogo from '../assets/images/tio_consultancy_logo.png';
import youthALiveKenyaLogo from '../assets/images/youth_alive_kenya_logo.png';
import ubuntuVoiceAndImpact from '../assets/images/ubuntu_voice_and_impact.jpeg';
import mayForty from '../assets/images/may_forty.png';
import aliveAndWell from '../assets/images/alive_and_well.jpeg';
import scouts from '../assets/images/scouts.jpeg';

const partners = [
  {
    id: 'jiwakilishe',
    name: 'Jiwakilishe',
    logo: jiwakilisheLogo,
    description: 'Community Based Organization',
    website: 'https://www.facebook.com/p/Jiwakilishe-CBO-100063469526714/',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain'
    },
    animationDelay: '0s'
  },
  {
    id: 'thrive-empowerment',
    name: 'Thrive Empowerment',
    logo: thriveEmpowermentLogo,
    description: 'Youth Empowerment',
    website: 'https://www.instagram.com/thrive_empowerment_org/',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain',
      borderRadius: '50%'
    },
    animationDelay: '0.1s'
  },
  {
    id: 'tio-consultancy',
    name: 'TIO Consultancy',
    logo: tioConsultancyLogo,
    description: 'Mental Health Support',
    website: '#tio_consultancy',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain',
      borderRadius: '50%'
    },
    animationDelay: '0.2s'
  },
  {
    id: 'youth-alive-kenya',
    name: 'Youth Alive Kenya',
    logo: youthALiveKenyaLogo,
    description: 'Youth Development',
    website: 'https://youthalivekenya.org/',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain'
    },
    animationDelay: '0.3s'
  },
  {
    id: 'ubuntu-voice-and-impact',
    name: 'Ubuntu Voice And Impact',
    logo: ubuntuVoiceAndImpact,
    description: 'Ubuntu Voice and Impact',
    website: '#ubuntu_voice_and_impact',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain'
    },
    animationDelay: '0.3s'
  },
  {
    id: 'alive-and-well',
    name: 'Alive and Well',
    logo: aliveAndWell,
    description: 'Alive and well',
    website: '#alive_and_well',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain'
    },
    animationDelay: '0.3s'
  },
  {
    id: 'may-40rty',
    name: 'May 40rty',
    logo: mayForty,
    description: 'May 40rty',
    website: '#may_forty',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain'
    },
    animationDelay: '0.3s'
  },
  {
    id: 'scouts',
    name: 'Scouts',
    logo: scouts,
    description: 'Scouts',
    website: 'https://shiw.org/',
    logoStyle: {
      maxHeight: '100px',
      maxWidth: '300px',
      objectFit: 'contain'
    },
    animationDelay: '0.3s'
  },
];

export default partners;